module.exports = __webpack_public_path__ + "static/media/worldwide.aea88ec4.gif";